import React from 'react';
import Accordion from "react-bootstrap/Accordion";

const App4 = () => {

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Особые права (льготы)</h2>
            <p>
                Право на прием на обучение в пределах особой квоты имеют дети-инвалиды, инвалиды I и II групп, инвалиды
                с
                детства,
                инвалиды вследствие военной травмы или заболевания, полученных в период прохождения военной службы,
                дети-сироты и дети,
                оставшиеся без попечения родителей, а также лица из числа детей-сирот и детей, оставшихся без попечения
                родителей, и ветераны
                боевых действий из числа лиц, указанных в подпунктах 1 - 4 пункта 1 статьи 3 Федерального закона от 12
                января 1995 г. № 5-ФЗ
                «О ветеранах».
            </p>
            <p>
                Право на прием на обучение в пределах особой квоты также имеют лица, признанные инвалидами I, II или III
                группы после получения
                высшего образования, которые вправе повторно получить высшее образование соответствующего уровня по
                другой
                специальности или
                направлению подготовки за счет ассигнований федерального бюджета.
            </p>
            <h6>Особые права при приёме на обучение для участников СВО и их детей</h6>
            <p>
                Федеральным законом от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации» предусмотрены особые права (льготы) при приёме на обучение по программам бакалавриата и специалитета <b>для участников СВО и их детей</b>, в том числе право на приём за счёт бюджетных ассигнований в рамках отдельной квоты.<br/>
                Льготы для поступления детей участников СВО в том числе распространяются на неродных усыновлённых детей. Отнесение к категориям лиц, имеющих право на поступление в рамках отдельной квоты, подтверждается соответствующей справкой, предоставляемой в установленном порядке.
            </p>
            <h5 style={{textAlign: "center"}}>При поступлении по особой квоте предоставляются следующие документы:</h5>
            <table>
                <thead>
                <tr>
                    <th>Категория</th>
                    <th>Вид документа</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Участники СВО и их дети</td>
                    <td>Справка</td>
                </tr>
                <tr>
                    <td>Дети-инвалиды, Инвалиды I и II групп, Инвалиды с детства</td>
                    <td>Справка учреждения медико-социальной экспертизы (МСЭ)</td>
                </tr>
                <tr>
                    <td>
                        Инвалиды вследствие военной травмы или заболевания, полученных в период прохождения военной
                        службы
                    </td>
                    <td>
                        Справка учреждения медико-социальной экспертизы (МСЭ);
                        Документ о признании инвалидом вследствие военной травмы или заболевания, полученного в период
                        прохождения военной службы
                    </td>
                </tr>
                <tr>
                    <td>
                        Дети-сироты - это лица в возрасте до 18 лет, у которых умерли оба или единственный родитель.
                        Лица из числа детей-сирот - лица в возрасте от 18 до 23 лет, у которых, когда они находились в
                        возрасте до 18 лет, умерли оба или единственный родитель.
                    </td>
                    <td>
                        Справка из органа опеки и попечительства, подтверждающая статус «дети- сироты» или «лица из
                        числа
                        детей- сирот»
                    </td>
                </tr>
                <tr>
                    <td>Дети, оставшиеся без попечения родителей, - лица в возрасте до 18 лет, которые остались без
                        попечения единственного родителя или обоих родителей в связи с лишением их родительских прав
                        Лица из числа детей-сирот и детей, оставшихся без попечения родителей лица в возрасте от 18 до
                        23
                        лет, которые, когда они находились в возрасте до 18 лет, остались без попечения единственного
                        или
                        обоих родителей
                    </td>
                    <td>Справка из органа опеки и попечительства, подтверждающая статус «детей, оставшихся без попечения
                        родителей» или «лица из числа детей, оставшихся без попечения родителей»
                    </td>
                </tr>
                <tr>
                    <td>
                        Ветераны боевых действий
                    </td>
                    <td>
                        Удостоверение ветерана боевых действий
                        Военный билет
                    </td>
                </tr>
                </tbody>
            </table>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Количество мест</Accordion.Header>
                    <Accordion.Body><p>
                    Квота приема данных лиц, имеющих особое право, устанавливается организацией высшего образования
                        в
                        размере
                        не менее чем 10% общего объема контрольных цифр, выделенных организации высшего образования на
                        очередной год,
                        по каждой специальности и (или) направлению подготовки. <br/>
                        <a href="/pdf/Number_of_special_quota_places.pdf">Количество мест в пределах особой (отдельной)
                            квоты приема на обучение по программам бакалавриата и
                            специалитета на 2025-2026 учебный год</a>.
                    </p></Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Преимущественное право зачисления</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            <h6>Преимущественное право зачисления предоставляется следующим лицам:</h6>
                            <ul style={{listStyle: "decimal"}}>
                                <li>дети-сироты и дети, оставшиеся без попечения родителей, а также лица из числа
                                    детей-сирот и
                                    детей, оставшихся без попечения родителей;
                                </li>
                                <li>дети-инвалиды, инвалиды I и II групп;</li>
                                <li>граждане в возрасте до двадцати лет, имеющие только одного родителя-инвалида I
                                    группы,
                                    если
                                    среднедушевой доход семьи ниже величины прожиточного минимума, установленного в
                                    субъекте
                                    Российской Федерации по месту жительства указанных граждан;
                                </li>
                                <li>граждане, которые подверглись воздействию радиации вследствие катастрофы на
                                    Чернобыльской
                                    АЭС и на которых распространяется действие Закона Российской Федерации от 15 мая
                                    1991 г.
                                    N
                                    1244-1 "О социальной защите граждан, подвергшихся воздействию радиации вследствие
                                    катастрофы
                                    на Чернобыльской АЭС";
                                </li>
                                <li>дети военнослужащих, погибших при исполнении ими обязанностей военной службы или
                                    умерших
                                    вследствие увечья (ранения, травмы, контузии) либо заболеваний, полученных ими при
                                    исполнении обязанностей военной службы, в том числе при участии в проведении
                                    контртеррористических операций и (или) иных мероприятий по борьбе с терроризмом;
                                </li>
                                <li>дети умерших (погибших) Героев Советского Союза, Героев Российской Федерации и
                                    полных
                                    кавалеров ордена Славы;
                                </li>
                                <li>дети сотрудников органов внутренних дел, Федеральной службы войск национальной
                                    гвардии
                                    Российской Федерации, учреждений и органов уголовно-исполнительной системы,
                                    федеральной
                                    противопожарной службы Государственной противопожарной службы, органов по контролю
                                    за
                                    оборотом наркотических средств и психотропных веществ, таможенных органов,
                                    Следственного
                                    комитета Российской Федерации, погибших (умерших) вследствие увечья или иного
                                    повреждения
                                    здоровья, полученных ими в связи с выполнением служебных обязанностей, либо
                                    вследствие
                                    заболевания, полученного ими в период прохождения службы в указанных учреждениях и
                                    органах,
                                    и дети, находившиеся на их иждивении;
                                </li>
                                <li>дети прокурорских работников, погибших (умерших) вследствие увечья или иного
                                    повреждения
                                    здоровья, полученных ими в период прохождения службы в органах прокуратуры либо
                                    после
                                    увольнения вследствие причинения вреда здоровью в связи с их служебной
                                    деятельностью;
                                </li>
                                <li>военнослужащие, которые проходят военную службу по контракту, и непрерывная
                                    продолжительность военной службы по контракту которых составляет не менее трех лет,
                                    а
                                    также
                                    граждане, прошедшие военную службу по призыву и поступающие на обучение по
                                    рекомендациям
                                    командиров, выдаваемым гражданам в порядке, установленном федеральным органом
                                    исполнительной
                                    власти, в котором федеральным законом предусмотрена военная служба;
                                </li>
                                <li>граждане, проходившие в течение не менее трех лет военную службу по контракту в
                                    Вооруженных
                                    Силах Российской Федерации, других войсках, воинских формированиях и органах на
                                    воинских
                                    должностях и уволенные с военной службы по основаниям, предусмотренным подпунктами
                                    "б" -
                                    "г"
                                    пункта 1, подпунктом "а" пункта 2 и подпунктами "а" - "в" пункта 3 статьи 51
                                    Федерального
                                    закона от 28 марта 1998 г. N 53-ФЗ "О воинской обязанности и военной службе";
                                </li>
                                <li>инвалиды войны, участники боевых действий, а также ветераны боевых действий из числа
                                    лиц,
                                    указанных в подпунктах 1 - 4 пункта 1 статьи 3 Федерального закона от 12 января 1995
                                    г.
                                    N
                                    5-ФЗ "О ветеранах";
                                </li>
                                <li>граждане, непосредственно принимавшие участие в испытаниях ядерного оружия, боевых
                                    радиоактивных веществ в атмосфере, ядерного оружия под землей, в учениях с
                                    применением
                                    таких
                                    оружия и боевых радиоактивных веществ до даты фактического прекращения указанных
                                    испытаний и
                                    учений, непосредственные участники ликвидации радиационных аварий на ядерных
                                    установках
                                    надводных и подводных кораблей и других военных объектах, непосредственные участники
                                    проведения и обеспечения работ по сбору и захоронению радиоактивных веществ, а также
                                    непосредственные участники ликвидации последствий этих аварий (военнослужащие и лица
                                    из
                                    числа вольнонаемного состава Вооруженных Сил Российской Федерации, военнослужащие
                                    внутренних
                                    войск Министерства внутренних дел Российской Федерации, военнослужащие и сотрудники
                                    Федеральной службы войск национальной гвардии Российской Федерации, лица,
                                    проходившие
                                    службу
                                    в железнодорожных войсках и других воинских формированиях, сотрудники органов
                                    внутренних
                                    дел
                                    Российской Федерации и федеральной противопожарной службы Государственной
                                    противопожарной
                                    службы);
                                </li>
                                <li>военнослужащие, сотрудники Федеральной службы войск национальной гвардии Российской
                                    Федерации, органов внутренних дел Российской Федерации, уголовно-исполнительной
                                    системы,
                                    федеральной противопожарной службы Государственной противопожарной службы,
                                    выполнявшие
                                    задачи в условиях вооруженного конфликта в Чеченской Республике и на прилегающих к
                                    ней
                                    территориях, отнесенных к зоне вооруженного конфликта, и указанные военнослужащие,
                                    выполняющие задачи в ходе контртеррористических операций на территории
                                    Северо-Кавказского
                                    региона.
                                </li>
                                <li>Преимущественное право зачисления в организации высшего образования, находящиеся в
                                    ведении
                                    федеральных государственных органов, также предоставляется выпускникам
                                    общеобразовательных
                                    организаций, профессиональных образовательных организаций, находящихся в ведении
                                    федеральных
                                    государственных органов и реализующих дополнительные общеобразовательные программы,
                                    имеющие
                                    целью подготовку несовершеннолетних обучающихся к военной или иной государственной
                                    службе.
                                </li>
                            </ul>
                        </p>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

export default App4;